import { Component, OnInit, Input, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ColumnDefinition, ColumnVisibility } from '../../../core/model/column-definition';
import { ColumnDefinitionFactory } from '../../../core/service/factory/column-definition-factory.service';
import { MultiselectListViewComponent } from '../../../core/component/list/multiselect-list-view/multiselect-list-view.component';
import { getMonthName } from '../../../core/helper/month';
import { ProfileService } from '../../../common/service/data/profile.service';

@Component({
  selector: 'app-preview-invoices',
  templateUrl: './preview-invoices.component.html',
  styleUrls: ['./preview-invoices.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PreviewInvoicesComponent implements OnInit {
  constructor(
    private _factory: ColumnDefinitionFactory,
    private _profileService: ProfileService
  ) {}

  @Input() dataContext: any;
  @Input() from: { year: number; month: string } | null = null;
  @Input() to: { year: number; month: string } | null = null;

  columnDefinition: ColumnDefinition[] = [];
  get samePeriod(): boolean {
    if (!this.from || !this.to) {
      return false;
    }
    return this.from.year === this.to.year && this.from.month === this.to.month;
  }

  autoAttest: boolean = false;

  private _getColumnDefinitionGroup() {
    let columns = [
      this._factory.createDate('INVOICE.PREVIEW.DUE_DATE', 'dueDate'),
      this._factory.create('INVOICE.PREVIEW.REFERS_TO_PERIOD', 'refersToPeriod'),
      this._factory.createMoney('INVOICE.PREVIEW.AMOUNT', 'amount'),
      this._factory.createMoney('INVOICE.PREVIEW.VAT', 'vat'),
      this._factory.createMoney('INVOICE.PREVIEW.ROUNDING', 'rounding'),
      this._factory.createMoney('INVOICE.PREVIEW.TOTAL_AMOUNT', 'totalAmount'),
      this._factory.create('INVOICE.RECIPIENT_NAME', 'invoiceRecipient'),
      this._factory.create('INVOICE.DELIVERY_ADDRESS', 'deliveryAddress'),
      this._factory.create('INVOICE.DELIVERY_METHOD', 'invoiceDeliveryMethodText', ColumnVisibility.optional),
      this._factory.create('LEASE_AGREEMENT.LEASE_AGREEMENT_NUMBER', 'ourReference', ColumnVisibility.optional),
    ];
    return columns;
  }

  monthToString(monthNumber: string): string {
    return getMonthName(parseInt(monthNumber));
  }

  ngOnInit() {
    this.columnDefinition = this._getColumnDefinitionGroup();
    this._profileService.getConfig().subscribe(data => {
      this.autoAttest = data.autoAttest;
    });
  }
}
